// extracted by mini-css-extract-plugin
export default {"savedPlace":"SavedPlace_savedPlace__UrRKi","savedPlaceHeart":"SavedPlace_savedPlaceHeart__8yWAQ"};